const INLINE_AUTH_MODES = Object.freeze({
    MAGIC_EMAIL: "magic-email",
    MAGIC_CODE: "magic-code",
    SSO_EMAIL: "sso-email",
    RESET_PASSWORD: "reset-password",
    EMAIL_VERIFICATION: "email-verification"
});

export { INLINE_AUTH_MODES };
export default INLINE_AUTH_MODES;
